/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceIpadCode = createReactComponent("device-ipad-code", "IconDeviceIpadCode", [
  [
    "path",
    {
      d: "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 18h2", key: "svg-1" }],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-2" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-3" }]
]);

export { IconDeviceIpadCode as default };
//# sourceMappingURL=IconDeviceIpadCode.js.map
